module.exports = __webpack_public_path__ + "media/images/app/become-vendor/prob1-c1d360006771f3eeedb3732aba8aa5f4.webp";